<template>
  <NuxtLinkLocale
    prefetch
    :to="`${getProductUrlV2(productSlug, artworkSlug)}?${by && `from=${by}`}`"
    :class="
      twJoin(
        'space-y-6 min-w-[240px] max-w-[240px] md:max-w-[282px] cursor-pointer [&>div>img]:hover:scale-105',
        productListing &&
          'max-[520px]:min-w-[unset] max-[1024px]:!max-w-[unset] min-h-[180px]'
      )
    "
    @click="handleSelectItem"
  >
    <div
      :class="
        twJoin(
          'bg-[#F6F5F4] h-[366px] md:h-[432px]',
          productListing && 'max-[520px]:!h-[auto]'
        )
      "
    >
      <div
        v-if="!imageUrl"
        class="text-gray-50 font-medium flex justify-center items-center w-full h-full opacity-50 min-h-[170px]"
      >
        No Image
      </div>
      <ProductListTagsComponent
        :tags="tags"
        class="absolute flex flex-col justify-start items-start"
      />
      <img
        v-if="imageUrl"
        loading="lazy"
        :alt="name?.toLowerCase() ?? ''"
        format="webp"
        :src="localImage ? imageUrl : config.public.mediaUrl + imageUrl"
        class="w-full h-full min-h-[170px] object-cover pt-[20px] transition-all ease-in-out"
      />
    </div>
    <div class="flex flex-col">
      <div class="flex justify-between font-medium h-[72px]">
        <div class="line-clamp-3">{{ name }}</div>
        <div class="ml-[10px]">{{ displayPrice(price) }}</div>
      </div>
      <div v-if="deviceOptionAvailable" class="text-sm text-gray-50">
        {{ $t('products.deviceOptions') }}
      </div>
    </div>
  </NuxtLinkLocale>
</template>
<script lang="ts" setup>
import { twJoin } from 'tailwind-merge'

const route = useRoute()
const query = computed(() => route.query)

const ProductListTagsComponent = defineAsyncComponent({
  loader: () => import('./ProductListTags.vue')
})

const by = computed(() => (query.value.by as string) || '')

const { on } = useEventTracking()
const emit = defineEmits<{
  (e: 'loading', value: boolean): void
}>()
const props = defineProps<{
  imageUrl: string
  localImage?: boolean
  productListing?: boolean
  name: string
  personalizable?: boolean
  magsafeCompatible?: boolean
  festive?: boolean
  tags?: { th?: string; en: string; color?: string }[]
  price: string | number
  deviceOptionAvailable?: boolean
  productSlug: string
  artworkSlug?: string | null
  productVariantDetailName?: string
  artworkName?: string | null
  productDetailType?: boolean
}>()

const handleSelectItem = () => {
  if (props.productDetailType) {
    emit('loading', true)
  }
  on('select_item', {
    item_category: getItemCategory(),
    item_name: props.name,
    ...(props.artworkName && { artwork_name: props.artworkName })
  })
}

const config = useRuntimeConfig()
</script>
